import { useParams, useNavigate } from 'react-router-dom'
import Empty from '../../ui/Empty/Empty'
import css from './WorkspacePrivateProjectPage.module.css'

// Shown when a project in the current workspace can't be opened. The client can't tell a
// deleted/non-existent project from a private one it isn't shared into — Firestore denies both
// reads the same way — so the copy covers both and always offers a way out (SCD-934, #7).
const WorkspacePrivateProjectPage = () => {
    const navigate = useNavigate()
    const { workspace } = useParams<{ workspace: string }>()

    return (
        <div className={css.container}>
            <Empty
                title="Can't open this project"
                text={<>This project doesn't exist, was deleted, <br/>or you don't have access to it.</>}
                buttonTitle="Go to projects"
                onClick={() => navigate(workspace ? `/${workspace}/projects` : '/', { replace: true })}
                testId="project-unavailable"
            />
        </div>
    )
}

export default WorkspacePrivateProjectPage
